import styled from 'styled-components';

interface IRootProps {
  colorValue?: string;
};

export const Root = styled.div`
  align-items: center;
`

export const FileUploadLabel = styled.div`
  display: block;
  margin-bottom: 36px;
`

export const CheckIcon = styled.div`
  text-align: center;
`


